import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";

const useStyles = makeStyles({
  puller: {
    width: 50,
    height: 6,
    position: "absolute",
    top: 10,
    left: "calc(50% - 25px)",
    borderRadius: 3,
    backgroundColor: "#ddd",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  reasonsParentContainer: {
    margin: "6px",
    color: "black",
    fontWeight: "600",
    fontSize: "18px",
  },
  reasonContainer: {
    margin: "6px",
    boxShadow: "0 0 10px #CCCCCC",
    borderRadius: "10px",
    padding: "4px",
  },
  rejectButtonContainer: {
    background: "#9D2123",
    height: "50px",
    borderRadius: "0",
    color: "white",
    "&:hover": {
      backgroundColor: "#9D2123",
    },
  },
});
export default function FARejectOrderReasonsDrawer(props) {
  const classes = useStyles();
  const handleChange = (event) => {
    props.setSelectedRejectReason(event.target.value);
  };

  const onCloseClicked = () => {
    const closeEventData = {
      page: "Field Agent Return Order Details",
      type: "Close Clicked Reject Bottom Sheet",
    };
    AnalyticsService.pushEvent("Button Clicked", closeEventData);
    props.setShowRejectReasons(false);
  };

  const onRejectClicked = () => {
    const rejectEventData = {
      page: "Field Agent Return Order Details",
      type: "Reject Clicked Bottom Sheet",
      reason: props?.selectedRejectReason,
    };
    AnalyticsService.pushEvent("Button Clicked", rejectEventData);
    props.handleRejectionCallback();
  };

  return (
    <SwipeableDrawer
      anchor={`bottom`}
      open={props.showRejectReasons}
      disableDiscovery={true}
      disableSwipeToOpen={true}
      onOpen={() => AndroidService.unsetPullToRefresh()}
      onClose={() => {
        AndroidService.setPullToRefresh();
        props.setShowRejectReasons(false);
      }}
      sx={{
        "& .MuiDrawer-paper": {
          borderTopLeftRadius: 30,
          borderTopRightRadius: 30,
        },
      }}
    >
      <Box className={classes.container}>
        <div className={classes.puller}></div>
        <img
          src="/icons/cross.svg"
          style={{
            alignSelf: "end",
            margin: "20px 20px 10px 20px",
          }}
          onClick={() => {
            onCloseClicked();
          }}
        />
        <Box className={classes.contentContainer}>
          <FormControl sx={{ width: "100%", padding: "0 10px" }}>
            <FormLabel className={classes.reasonsParentContainer}>
              Select the reason for rejection
            </FormLabel>
            <RadioGroup onChange={handleChange}>
              {_.map(props.reasons, (reason, index) => {
                return (
                  <FormControlLabel
                    value={reason}
                    control={<Radio />}
                    label={reason}
                    key={index}
                    labelPlacement="end"
                    className={classes.reasonContainer}
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
          <Button
            fullWidth
            className={classes.rejectButtonContainer}
            onClick={() => onRejectClicked()}
            disabled={
              props?.selectedRejectReason === "" ||
              props?.selectedRejectReason === null
            }
            variant="contained"
          >
            {props.actionText}
          </Button>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}
